import type { RootState } from '@nx/state';
import { StoreKit } from '@nx/state';

import type { AppDispatch } from '../../store-kit';
import { triggerUseApi } from './guides-slice';

const triggerApiThunk = (dispatch: AppDispatch, getState: () => RootState) => {
  if (getState().guides.skipApi) {
    dispatch(triggerUseApi());
  }
};

export const triggerApi = () => {
  const { globalStore } = StoreKit.UNSAFE_getGlobalStoreInstance();
  globalStore.dispatch(triggerApiThunk);
};
